import React, {useCallback, useState} from 'react'
import Box from '@material-ui/core/Box';
import AccessibilityIcon from '@material-ui/icons/Accessibility'
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew'
import {switchUserHandler} from 'module/SessionInfo/api/SwitchUserAPI';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(theme => ({
	root: {
		color: ({hover}) => hover ? theme.palette.error.light : theme.palette.error.main,
		display: 'inline-flex',
		margin: theme.spacing(0, 0, 0, 1),
	},
}), {name: 'SwitchBackToDefaultUserButton'});

export const SwitchBackToDefaultUserButton = () => {
	const [hover, setHover] = useState(false);
	const classes = useStyles({hover});
	const onMouseEnter = useCallback(() => setHover(true), []);
	const onMouseLeave = useCallback(() => setHover(false), []);
	const resetUser = useCallback(() => switchUserHandler({reset: true}), []);
	return (
		<Tooltip title={"Zurück zum eigenen Benutzer wechseln"} enterDelay={0}>
			<Box className={classes.root} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={resetUser}>
				{hover &&
				<AccessibilityNewIcon/>
				||
				<AccessibilityIcon/>
				}
			</Box>
		</Tooltip>
	);
};